import React from 'react';
import styled from 'styled-components';
import { Breakpoints, Color, Grid, Type } from '../../../app/StyleGuide';
import { Container } from '../../../components/Layout';
import windowService from '../../../services/windowService';

const SubMenuContainerFluid = styled.div`
  z-index: 100;
  position: relative;
  background: ${Color.white};
  box-shadow: inset 0px 1px 2px rgba(70, 72, 84, 0.1);
  border-bottom: 1px solid ${Color.Gray._10};
`;

const Tabs = styled.ul`
  position: relative;
  z-index: 1;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    display: flex;
    border-bottom: 3px solid transparent;
    &:hover {
      border-color: ${Color.Gray._30};
    }
  }
  li.active-tab {
    border-color: ${Color.Orange._50};
    > button {
      i {
        color: ${Color.Orange._50};
      }
      color: ${Type.Color.dark};
      font-weight: ${Type.Weight.semibold};
    }
  }
  li:not(.active-tab) > button {
    cursor: pointer;
  }
  button {
    border: 0;
    background: none;
    padding: ${Grid._4} ${Grid._3};
    text-align: center;
    font-size: ${Type.Scale._3};
    color: ${Type.Color.medium};
    span,
    i {
      color: ${Color.Secondary._50};
      margin-right: ${Grid._3};
    }
    &:focus {
      outline: none;
    }
    @media screen and (min-width: ${Breakpoints.screen_sm}) {
      padding: ${Grid._4} ${Grid._5};
      text-align: left;
    }
  }
`;

export default function TrainingSubMenu({ activeTab }: { activeTab: 'catalog' | 'search' }) {
  return (
    <SubMenuContainerFluid>
      <Container>
        <Tabs>
          <li className={activeTab === 'catalog' ? 'active-tab' : ''}>
            <button
              data-qa-hook="subMenuTabCatalog"
              onClick={() => (activeTab !== 'catalog' ? windowService.redirectTo('#/catalog') : null)}
            >
              <i className="fas fa-grip-horizontal"></i> Catalog
            </button>
          </li>
          <li className={activeTab === 'search' ? 'active-tab' : ''}>
            <button
              data-qa-hook="subMenuTabSearch"
              onClick={() => (activeTab !== 'search' ? windowService.redirectTo('#/search') : null)}
            >
              <i className="icon ion-ios-search-strong"></i>Search
            </button>
          </li>
        </Tabs>
      </Container>
    </SubMenuContainerFluid>
  );
}
